// In development (nx serve), module-federation.config.ts provides localhost URLs for each remote.
// In production (CloudFront), rspack.ts overrides those URLs to relative paths (e.g. /home/remoteEntry.js)
// so all remotes resolve to the same CloudFront origin automatically — no runtime magic needed.
import('./bootstrap').catch((err) => console.error(err));
